/**
 * `/hr/employees` — l'elenco dei dipendenti, come `/erp-employee` di Lares (19-10-2026).
 *
 * La voce «Dipendenti» del menu portava a `/workforce`, che si apre sulla Dashboard di Segreteria
 * & HR: chi cercava una persona trovava dei grafici. Qui c'è l'elenco e basta. `/workforce` resta
 * com'è finché non si decide che fine fa; la tabella è la stessa (`EmployeesTable`).
 *
 * Sul telefono la schermata dei dipendenti è quella di sempre (`MobileWorkforce`).
 *
 * `?type=external` apre l'elenco sugli esterni, con partita IVA e tariffa in colonna: è dove porta
 * «Personale esterno» dal 03-11-2026.
 */
import { createFileRoute } from '@tanstack/react-router';
import { EmployeesListPage } from '@/features/workforce/EmployeesListPage';
import { MobileWorkforce } from '@/features/workforce/mobile/MobileWorkforce';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';

export const Route = createFileRoute('/_app/hr/employees/')({
  validateSearch: (s: Record<string, unknown>): { type?: 'external' | 'internal' } => ({
    type: s.type === 'external' || s.type === 'internal' ? s.type : undefined,
  }),
  component: EmployeesPage,
});

function EmployeesPage() {
  const { type } = Route.useSearch();
  return useIsMobileShell() ? <MobileWorkforce /> : <EmployeesListPage initialType={type} />;
}
